module.exports = {
  entry: './src/apps/rpa-price-estimator/index.tsx',
  shortcode: 'rpa-price-estimator',
  title: 'Robotic Process Automation Price Estimator',
  status: 'stable',
  description: 'Allows users to determine a price.',
  preview: {
    url: `${process.env.PUBLIC_URL}/storybook/iframe.html?id=widgets-rpa-price-estimator-components--default&viewMode=story`,
  },
  useExternalPeerDependencies: ['react', 'react-dom', 'react-intl'],
  additionalCustomProperties: {
    webSegmentPaths: ['/cloud'],
    availableTranslations: [
      'de',
      'en',
      'es',
      'esla',
      'fr',
      'it',
      'ja',
      'ko',
      'pt',
      'zh-cn',
    ],
    org: 'digitalsales', // to filter the widget
    brand: 'automation', // automation, dataai, security, sustainabilty, storage, other
    widgetLocation: '/pricing', // default '/pricing' but sometimes '/'
    productName: 'robotic-process-automation', // the product name in the URL
    activatedCountryPages: [
      'us-en',
      'br-pt',
      'de-de',
      'es-es',
      'fr-fr',
      'id-id',
      'it-it',
      'jp-ja',
      'kr-ko',
      'mx-es',
    ],
  },
};
